export const LOGIN = "login"

export const MenuResto = {
    HOME: 'home',
    TODAY_RESERVATIONS: 'todayReservations',
    RESERVATION_BY_ID: 'reservationById',
    RESERVATIONS_HISTORICAL: 'reservationsHistorical',
    RESERVATIONS_CONFIGURATION: 'reservationsConfiguration',
    RESERVATIONS_USERS_ASSISTED: 'reservationsUsersAssisted',
    ANALYTICAL: 'analytical',
    PROFILE: 'profile',
    COMMENTS: 'comments',
    PROMOTIONS: 'promotions',
    PROMOTIONS_PER_DAY: 'promotionsPerDay',
    CONFIGURATION_BUSINESS_DAYS: 'configurationBusinessDays',
    CONFIGURATIONS_GENERAL: 'configurationsGeneral',
    LOGOUT: 'logout',
};

export const MenuAdmin = {
    HOME: 'home',
    ANALYTICAL_RESERVATIONS_PER_DAY: 'analyticalReservationsPerDay',
    ANALYTICAL_RESERVATIONS_RANGE: 'analyticalReservationsRange',
    RESTAURANTS_ADMIN: 'restaurantsAdmin',
    RESTAURANTS_PRIORITY_ADMIN: 'restaurantsPriority',
    USERS_ADMIN: 'usersAdmin',
    CONFIGURATIONS_GENERAL: 'configurationsGeneral',
    LOGOUT: 'logout',
};